import { io, Socket } from 'socket.io-client';

type SocketEventHandler = (...args: any[]) => void;

const REALTIME_SOCKET_PATH = '/realtime/socket.io';

let activeSocket: Socket | null = null;
let activeSocketToken: string | null = null;

export const addSocketEventListener = (event: string, handler: SocketEventHandler): void => {
  activeSocket?.on(event, handler);
};

export const removeSocketEventListener = (event: string, handler: SocketEventHandler): void => {
  activeSocket?.off(event, handler);
};

export const disconnectRealtimeSocket = (): void => {
  activeSocket?.disconnect();
  activeSocket = null;
  activeSocketToken = null;
};

export const isRealtimeSocketConnectedWithToken = (token: string): boolean =>
  !!activeSocket?.connected && activeSocketToken === token;

export const connectRealtimeSocket = (url: string, token: string): Socket => {
  activeSocket?.disconnect();
  activeSocket = null;
  activeSocketToken = token;

  const socket = io(url, {
    path: REALTIME_SOCKET_PATH,
    auth: { token },
    transports: ['websocket', 'polling'],
    forceNew: true,
  });

  activeSocket = socket;

  return socket;
};
